module.exports = __webpack_public_path__ + "img/d659242.png";